import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const Booking = () => {
    const [checkIn, setCheckIn] = useState('');
    const [checkOut, setCheckOut] = useState('');
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const [room, setRooms] = useState(0);

    const navigate = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        // Process the booking with the captured values
        const bookingDetails = {
            checkIn,
            checkOut,
            adults,
            children,
            room,
        };

        console.log('Booking details:', bookingDetails);

        // Navigate to the next page with the booking details
        navigate('/rooms', { state: bookingDetails });
    };

    return (
        <>
            <div className="container-fluid booking pb-5 wow fadeIn" data-wow-delay="0.1s ff">
                <div className="container fff">
                    <div className="bg-white shadow" style={{ padding: '35px' }}>
                        <form onSubmit={handleSubmit}>
                            <div className="row g-2 align-items-center">
                                <div className="col-md-10">
                                    <div className="row g-2">
                                        
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="adult">No of Adult</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="adult"
                                                    value={adults}
                                                    min="0"
                                                    max="10"
                                                    onChange={(e) => setAdults(parseInt(e.target.value))}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="child">No of Child</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="child"
                                                    value={children}
                                                    min="0"
                                                    max="10"
                                                    onChange={(e) => setChildren(parseInt(e.target.value))}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="room">No of rooms</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    id="room"
                                                    value={room}
                                                    min="0"
                                                    max="10"
                                                    onChange={(e) => setRooms(parseInt(e.target.value))}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2 d-flex align-items-center">
                                    <button type="submit" className="btn btn-primary w-100">
                                        Search
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};